import {ajaxErrorAlert, ajaxPost, parceAjaxErrorResponse} from "./utils";
import {ErrorSwal, getJsContext, SuccessSwal, SwalPost} from "../app";
import {bsModal} from "./plugins";
import lo from "datatables.net-plugins/i18n/lo.mjs";

$(function () {
  const body = $("body");

  if (
    body.hasClass("payments") ||
    body.hasClass("payments_policy") ||
    body.hasClass("payments_pre_policy") ||
    body.hasClass("payments_subrogation")
  ) {
    const table = $("#paymentListTable");
    const form = $("#paymentFilterForm");

    table.DataTable({
      ajax: {
        type: "POST",
        data: function (d) {
          for (let v of Object.values(form.serializeArray())) {
            d[v.name] = v.value;
          }
        },
      },
      rowCallback: function (nRow, aData) {
        if ($(this).find("th[data-column=actions]").length > 0) {
          const rowActions = `<div class="btn-group" role="group">
            <button type="button" class="rowActionMenuBtn btn btn-sm btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
               ${getJsContext('action')}
            </button>
            <ul class="rowActionMenu dropdown-menu rounded-1 shadow">
              <div class="d-flex justify-content-center align-items-center p-2">
                <div class="spinner-border text-secondary" role="status" style="border-width: 1px"></div>
              </div>
            </ul>
          </div>`;
          $(nRow).find("td:last-of-type").addClass('text-end').append(rowActions);
        }
        if ("id" in aData) {
          $(nRow).attr("id", aData["id"]);
        }
        if ("table_row_class" in aData) {
          $(nRow).addClass(aData["table_row_class"]);
        }
      },
    });

    form.on("submit", (e) => {
      e.preventDefault();
      table.DataTable().ajax.reload();
      $(body).modal("hideAll");
    });

    $(document).on("click", ".rowActionMenuBtn", (e) => {
      const btn = $(e.currentTarget);
      const paymentId = btn.closest("tr").attr("id");
      const menu = btn.parent().find(".rowActionMenu");

      const data = {
        action: "get_row_action_menu",
        payment_id: paymentId,
      }

      ajaxPost('/admin/payments/ajax/', data, btn).then((response) => {
        menu.html(String(response["html"]));
      });
    });

    $(document).on("click", ".paymentDetailBtn", (e) => {
      const paymentId = $(e.target).data('payment-id');
      const paymentDetailModal = bsModal("full", {
        title: getJsContext("payment_detail"),
        modalId: "paymentDetailModal",
        backdrop: "none",
      });
      const data = {
        action: "get_payment_detail",
        payment_id: paymentId,
      }
      ajaxPost("/admin/payments/ajax/", data)
        .then((response) => {
          $(paymentDetailModal).modal("content", response.html);
        })
        .catch((errors) => {
          ErrorSwal.fire({
            html: parceAjaxErrorResponse(errors).join("<br>"),
          }).then(() => {
            $(paymentDetailModal).modal("hide");
          });
        });
    });

    $("#exportPayments").on("click", (e) => {
      e.preventDefault();
      const button = $(e.currentTarget);
      const data = form.serializeArray();
      data.push({name: "action", value: "export"});
      data.push({name: "payment_category", value: button.data("payment-category")});
      button.attr("disabled", "disabled");

      ajaxPost("", data, form)
        .then((response) => {
          if (response["has_file"]) {
            window.location.href = String(response["file_url"]);
            $(".userNotificationsModal").first().trigger("click");
          } else {
            SuccessSwal.fire({
              title: "Fayl hazırlanır",
              text: String(response["message"]),
            }).then(() => {
              $(".userNotificationsModal").first().trigger("click");
            });
          }
        })
        .catch((errors) => {
          ajaxErrorAlert(errors, form);
        })
        .finally(() => {
          button.removeAttr("disabled");
        });
    });

    $(document).on('click', '.paymentEditBtn', (e) => {
      e.preventDefault();
      const paymentId = $(e.currentTarget).data('payment-id');

      const modal = bsModal("full", {
        title: getJsContext('update_payment'),
        modalId: "updatePaymentModal",
        backdrop: "none",
      });

      const data = {
        id: paymentId,
        action: "update_modal"
      }

      ajaxPost("/admin/payments/ajax/", data)
        .then((response) => {
          $(modal).modal("content", response["html"]);
        })
        .catch((errors) => {
          ErrorSwal.fire({
            html: parceAjaxErrorResponse(errors),
          }).then(() => {
            $(modal).modal("hide");
          });
        });
    });

    $(document).on('click', '.paymentReverseBtn', (e) => {
      e.preventDefault();
      const paymentId = $(e.currentTarget).data('payment-id');

      const modal = bsModal("full", {
        title: getJsContext('reverse_payment'),
        modalId: "reversePaymentModal",
        backdrop: "none",
      });

      const data = {
        id: paymentId,
        action: "reverse_modal"
      }

      ajaxPost("/admin/payments/ajax/", data)
        .then((response) => {
          $(modal).modal("content", response["html"]);
        })
        .catch((errors) => {
          ErrorSwal.fire({
            html: parceAjaxErrorResponse(errors),
          }).then(() => {
            $(modal).modal("hide");
          });
        });
    });

    $(document).on('submit', '#reversePaymentForm', (e) => {
      e.preventDefault();
      const form = $(e.target);
      const data = form.serializeArray();
      const modal = form.closest(".modal");

      form.loading({
        loadingText: getJsContext('please_wait') + '...',
        position: "center",
      });

      ajaxPost("/admin/payments/ajax/", data, form)
        .then(() => {
          SuccessSwal.fire({timer: 1000}).then(() => {
            table.DataTable().ajax.reload();
            $(modal).modal("hideAll");
          });
        })
        .catch((errors) => {
          ajaxErrorAlert(errors, form);
        });

    });

    $(document).on('click', '.checkPaymentStatusBtn', (e) => {
      e.preventDefault();
      const paymentId = $(e.currentTarget).data('payment-id');

      const data = {
        id: paymentId,
        action: "check_payment_status"
      }

      SwalPost("/admin/payments/ajax/", data).then(response => {
        console.log(response)
        $(document).modal('hideAll');
        table.DataTable().ajax.reload();
        SuccessSwal.fire({timer: 1000});
      });

    });
  }

  if (body.hasClass("products")) {
    const table = $("#productListTable");
    const form = $("#productFilterForm");

    table.DataTable({
      pageLength: 100,
      ajax: {
        type: "POST",
        data: function (d) {
          for (let v of Object.values(form.serializeArray())) {
            d[v.name] = v.value;
          }
        },
      },
      rowCallback: function (nRow, aData) {
        if ($(this).find("th[data-column=actions]").length > 0) {
          const rowActions = `<div class="btn-group" role="group">
            <button type="button" class="rowActionMenuBtn btn btn-sm btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
              ${getJsContext('action')}
            </button>
            <ul class="rowActionMenu dropdown-menu rounded-1 shadow">
              <div class="d-flex justify-content-center align-items-center p-2">
                <div class="spinner-border text-secondary" role="status" style="border-width: 1px"></div>
              </div>
            </ul>
          </div>`;
          $(nRow).find("td:last-of-type").addClass('text-end').append(rowActions);
        }
        if ("id" in aData) {
          $(nRow).attr("id", aData["id"]);
        }
        if ("table_row_class" in aData) {
          $(nRow).addClass(aData["table_row_class"]);
        }
      },
    });

    form.on("submit", (e) => {
      e.preventDefault();
      table.DataTable().ajax.reload();
      $(body).modal("hideAll");
    });

    $(document).on("click", ".rowActionMenuBtn", (e) => {
      const btn = $(e.currentTarget);
      const productId = btn.closest("tr").attr("id");
      const menu = btn.parent().find(".rowActionMenu");

      const data = {
        action: "row_action_menu",
        id: productId,
      }

      ajaxPost('/admin/products/ajax/', data, btn).then((response) => {
        menu.html(String(response["html"]));
      });
    });

    $(document).on("click", ".productDetailBtn", (e) => {
      e.preventDefault();
      const productId = $(e.target).data('product-id');

      const modal = bsModal("full", {
        title: getJsContext('update_product'),
        modalId: "updateProductModal",
        backdrop: "none",
      });

      const data = {
        id: productId,
        action: "update_modal"
      }

      ajaxPost("/admin/products/ajax/", data)
        .then((response) => {
          $(modal).modal("content", response["html"]);
        })
        .catch((errors) => {
          ErrorSwal.fire({
            html: parceAjaxErrorResponse(errors),
          }).then(() => {
            $(modal).modal("hide");
          });
        });
    });

    $(document).on("click", ".productDeleteBtn", (e) => {
      e.preventDefault();
      const productId = $(e.target).data('product-id');

      e.preventDefault();
      const button = $(e.currentTarget);
      button.attr("disabled", "disabled");

      const data = {
        id: productId,
        action: "delete"
      }

      SwalPost("/admin/products/ajax/", data)
        .then(() => {
          SuccessSwal.fire({timer: 1000}).then(() => {
            $("#productFilterForm").trigger("submit");
          });
        })
    });

    $(document).on("click", "#createProduct", (e) => {
      e.preventDefault();

      const modal = bsModal("full", {
        title: getJsContext('create_product'),
        modalId: "createProductModal",
        backdrop: "none",
      });

      ajaxPost("/admin/products/ajax/", {action: "create_modal"})
        .then((response) => {
          $(modal).modal("content", response["html"]);
        })
        .catch((errors) => {
          ErrorSwal.fire({
            html: parceAjaxErrorResponse(errors),
          }).then(() => {
            $(modal).modal("hide");
          });
        });
    });

    $(document).on('submit', '#productForm', (e) => {
      e.preventDefault();
      const form = $(e.target);
      const data = form.serializeArray();

      form.loading({
        loadingText: getJsContext('please_wait') + '...',
        position: "center",
      });

      ajaxPost("/admin/products/ajax/", data, form)
        .then(() => {
          SuccessSwal.fire({timer: 1000}).then(() => {
            table.DataTable().ajax.reload();
          });
        })
        .catch((errors) => {
          ajaxErrorAlert(errors, form);
        });

    });
  }

  if (body.hasClass("tasks")) {
    const table = $("#taskListTable");
    const form = $("#taskFilterForm");

    table.DataTable({
      pageLength: 50,
      ajax: {
        type: "POST",
        data: function (d) {
          for (let v of Object.values(form.serializeArray())) {
            d[v.name] = v.value;
          }
        },
      },
      rowCallback: function (nRow, aData) {
        if ($(this).find("th[data-column=actions]").length > 0) {
          const rowActions = `<div class="btn-group" role="group">
            <button type="button" class="rowActionMenuBtn btn btn-sm btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
              ${getJsContext('action')}
            </button>
            <ul class="rowActionMenu dropdown-menu rounded-1 shadow">
              <div class="d-flex justify-content-center align-items-center p-2">
                <div class="spinner-border text-secondary" role="status" style="border-width: 1px"></div>
              </div>
            </ul>
          </div>`;
          $(nRow).find("td:last-of-type").addClass('text-end').append(rowActions);
        }
        if ("id" in aData) {
          $(nRow).attr("id", aData["id"]);
        }
        if ("table_row_class" in aData) {
          $(nRow).addClass(aData["table_row_class"]);
        }
      },
    });

    form.on("submit", (e) => {
      e.preventDefault();
      table.DataTable().ajax.reload();
      $(body).modal("hideAll");
    });

    $(document).on("click", ".rowActionMenuBtn", (e) => {
      const btn = $(e.currentTarget);
      const taskId = btn.closest("tr").attr("id");
      const menu = btn.parent().find(".rowActionMenu");

      const data = {
        action: "row_action_menu",
        task_id: taskId,
      }

      ajaxPost('/admin/tasks/ajax/', data, btn).then((response) => {
        menu.html(String(response["html"]));
      });
    });

    $(document).on("click", ".taskDetailBtn", (e) => {
      e.preventDefault();
      const taskId = $(e.target).data('task-id');

      const modal = bsModal("full", {
        title: getJsContext('task_detail'),
        modalId: "taskDetailModal",
        backdrop: "none",
      });

      const data = {
        task_id: taskId,
        action: "detail_modal"
      }

      ajaxPost("/admin/tasks/ajax/", data)
        .then((response) => {
          $(modal).modal("content", response["html"]);
        })
        .catch((errors) => {
          ErrorSwal.fire({
            html: parceAjaxErrorResponse(errors),
          }).then(() => {
            $(modal).modal("hide");
          });
        });
    });

    $(document).on('click', '.requeueTaskBtn', (e) => {
      e.preventDefault();
      const taskId = $(e.currentTarget).data('task-id');

      const data = {
        task_id: taskId,
        action: "requeue"
      }

      SwalPost("/admin/tasks/ajax/", data).then(response => {
        console.log(response)
        $(document).modal('hideAll');
        table.DataTable().ajax.reload();
        SuccessSwal.fire({timer: 1000});
      });

    });

    $(document).on("click", ".scheduleTaskModalBtn", (e) => {
      e.preventDefault();

      const modal = bsModal("full", {
        title: getJsContext('schedule_task'),
        modalId: "scheduleTaskModal",
        backdrop: "none",
      });

      ajaxPost("/admin/tasks/ajax/", {action: "schedule_modal"})
        .then((response) => {
          $(modal).modal("content", response["html"]);
        })
        .catch((errors) => {
          ErrorSwal.fire({
            html: parceAjaxErrorResponse(errors),
          }).then(() => {
            $(modal).modal("hide");
          });
        });
    });
  }

  if (body.hasClass("logs")) {
    const table = $("#logListTable");
    const form = $("#logFilterForm");

    table.DataTable({
      pageLength: 50,
      ajax: {
        type: "POST",
        data: function (d) {
          for (let v of Object.values(form.serializeArray())) {
            d[v.name] = v.value;
          }
        },
      },
      rowCallback: function (nRow, aData) {
        $(nRow).find("td:last-of-type").append(`
          <button data-log-id="${aData["id"]} " class="logDetailBtn btn btn-sm btn-secondary">Ətraflı</button>
        `);
      },
    });

    form.on("submit", (e) => {
      e.preventDefault();
      table.DataTable().ajax.reload();
      $(body).modal("hideAll");
    });

    $(document).on("click", ".rowActionMenuBtn", (e) => {
      const btn = $(e.currentTarget);
      const logId = btn.closest("tr").attr("id");
      const menu = btn.parent().find(".rowActionMenu");
      const data = {
        action: "row_action_menu",
        log_id: logId,
      }

      ajaxPost('/admin/logs/ajax/', data, btn).then((response) => {
        menu.html(String(response["html"]));
      });
    });

    $(document).on("click", ".logDetailBtn", (e) => {
      e.preventDefault();
      const logId = $(e.target).data('log-id');

      const modal = bsModal("full", {
        title: getJsContext('Log detail'),
        modalId: "logDetailModal",
        backdrop: "none",
      });

      const data = {
        log_id: logId,
        action: "detail_modal"
      }

      ajaxPost("/admin/logs/ajax/", data)
        .then((response) => {
          $(modal).modal("content", response["html"]);
        })
        .catch((errors) => {
          ErrorSwal.fire({
            html: parceAjaxErrorResponse(errors),
          }).then(() => {
            $(modal).modal("hide");
          });
        });
    });
  }

  if (body.hasClass("logged-in")) {
    $(document).on("click", ".updateSettings", (e) => {
      e.preventDefault();

      const modal = bsModal("full", {
        title: getJsContext('update_settings'),
        modalId: "updateSettingsModal",
      });

      ajaxPost("/admin/settings/ajax/", {action: "html"})
        .then((response) => {
          $(modal).modal("content", response["html"]);
        })
        .catch((errors) => {
          ErrorSwal.fire({
            html: parceAjaxErrorResponse(errors),
          }).then(() => {
            $(modal).modal("hide");
          });
        });
    });

    $(document).on('submit', '#settingsForm', (e) => {
      e.preventDefault();
      const form = $(e.target);
      const data = form.serializeArray();

      form.loading({
        loadingText: getJsContext('please_wait') + '...',
        position: "center",
      });

      ajaxPost("/admin/settings/ajax/", data, form)
        .then((response) => {
          SuccessSwal.fire({timer: 1000}).then(() => {
            console.log(response)
          });
        })
        .catch((errors) => {
          ajaxErrorAlert(errors, form);
        });

    });
  }

  $(".addPaymentModalBtn").on("click", (e) => {
    e.preventDefault();
    const data = {
      action: "add_payment_modal"
    };

    const modal = bsModal("medium", {
      title: getJsContext('add_payment'),
      modalId: "addPaymentModal",
      backdrop: "none",
      keyboard: true,
    });

    ajaxPost("/admin/payments/ajax/", data)
      .then((response) => {
        $(modal).modal("content", response["html"]);
      })
      .catch((errors) => {
        ErrorSwal.fire({
          html: parceAjaxErrorResponse(errors),
        }).then(() => {
          $(modal).modal("hide");
        });
      });
  });

  $(document).on('submit', '#addPaymentForm', (e) => {
    e.preventDefault();
    const form = $(e.target);
    const data = form.serializeArray();
    data.push({name: "action", value: "add_payment"});
    ajaxPost("/admin/payments/ajax/", data, form)
      .then(() => {
        SuccessSwal.fire({timer: 1000}).then(() => {
          window.location.reload();
        });
      })
      .catch((errors) => {
        ajaxErrorAlert(errors, form);
      });
  })
});